module.exports = __webpack_public_path__ + "img/logo-merca-2.a8ef831a.png";